import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialog) = $event)),
    title: "Document à importer",
    onValid: _cache[4] || (_cache[4] = ($event: any) => (_ctx.uploadDocumentsFromMail())),
    previousDisplay: false,
    validLoading: _ctx.loading,
    validTitle: _ctx.actionTitle,
    validDisabled: _ctx.actionDisabled,
    "min-width": "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex align-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_date_picker_filled, {
                modelValue: _ctx.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
                "hide-details": true,
                label: "Date de début",
                mandatory: false,
                textFieldReadOnly: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_date_picker_filled, {
                modelValue: _ctx.endDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
                "hide-details": true,
                label: "Date de fin",
                mandatory: false,
                readonly: "",
                textFieldReadOnly: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex align-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                modelValue: _ctx.onlyToUpload,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.onlyToUpload) = $event)),
                label: 'A importer uniquement'
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.report)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            "no-gutters": "",
            class: "d-flex align-center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.report), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_list, {
        style: {"background-color":"transparent"},
        lines: "two"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_virtual_scroll, {
            "item-height": 75,
            items: _ctx.filteredAttachments,
            height: "400",
            class: "py-3",
            bench: "2"
          }, {
            default: _withCtx(({ item }) => [
              (_openBlock(), _createBlock(_component_v_list_item, {
                key: item.importId,
                class: "oss-list-item-inactive",
                active: false,
                link: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "d-flex align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex pb-2 font-weight-bold align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    left: "",
                                    color: "secondary"
                                  }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                      _createTextVNode("$label")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "px-1 d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "secondary",
                                    size: "small",
                                    location: "start"
                                  }, {
                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                      _createTextVNode("$oss-calendar")
                                    ])),
                                    _: 1
                                  }),
                                  _createTextVNode(_toDisplayString(_ctx.formatDate(item.message.date)) + " " + _toDisplayString(_ctx.getAttachmentType(item)) + " - " + _toDisplayString(_ctx.getTo(item)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            class: "d-flex"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex font-weight-bold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getAttachmentStatus(item)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex caption"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString("De: " + _ctx.getSenderOrReceiver(item.from)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                class: "d-flex pb-2 caption"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString("À : " + _ctx.getSenderOrReceiver(item.to)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            ]),
            _: 1
          }, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "validLoading", "validTitle", "validDisabled"]))
}